<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="8.421" height="12.326"><g data-name="Arrows both directions" fill="none" stroke="#939393" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path data-name="Arrow Bign" d="M1.065 3.897l3.15-3.15 3.15 3.15M7.36 8.426l-3.15 3.15-3.15-3.15"/></g></svg>
</template>
<script>
  export default {
    name: 'IconArrowUpDown'
  }
</script>
